import { useSyncExternalStore } from "react";
import { storageKey } from "../config";
import { t } from "../locale";

// A local reminder preference, never evidence that an icon currently exists.
const key = storageKey("home-screen-reminder");
const changeEvent = "yestv:home-screen-reminder";
let memoryFallback = false;
export function readAcknowledged() {
  try { return memoryFallback || localStorage.getItem(key) === "acknowledged"; }
  catch { return memoryFallback; }
}
function subscribe(listener: () => void) {
  const onStorage = (event: StorageEvent) => {
    if (event.key === key || event.key === null) { memoryFallback = false; listener(); }
  };
  addEventListener("storage", onStorage);
  addEventListener(changeEvent, listener);
  return () => {
    removeEventListener("storage", onStorage);
    removeEventListener(changeEvent, listener);
  };
}
export function useInstallAcknowledged() {
  return useSyncExternalStore(subscribe, readAcknowledged);
}
export function acknowledgeInstall() {
  try { localStorage.setItem(key, "acknowledged"); memoryFallback = false; }
  catch { memoryFallback = true; }
  dispatchEvent(new Event(changeEvent));
}
let dismissedInMemory = false;
const dismissedKey = storageKey("home-screen-install-dismissed");
export function dismissInstallForSession() {
  dismissedInMemory = true;
  try { sessionStorage.setItem(dismissedKey, "1"); } catch { /* The current tab still remembers. */ }
}
export function shouldOfferInstall() {
  if (readAcknowledged() || dismissedInMemory) return false;
  try { return sessionStorage.getItem(dismissedKey) !== "1"; } catch { return true; }
}

export default function InstallReminder({ onClose, compact = false }: { onClose: () => void; compact?: boolean }) {
  const content = <>
    <p>{t("Return to your Home Screen and tap Yestv. There is no need to add another icon.")}</p>
    <p>{t("If the icon is missing or was deleted, follow the steps below to add it again.")}</p>
    <button type="button" onClick={() => { acknowledgeInstall(); onClose(); }}>{t("I’ve already added it")}</button>
    <small>{t("We’ll stop suggesting it here. You can still choose Add again later.")}</small>
  </>;
  return compact ? <details className="install-reminder install-reminder-compact"><summary>{t("Already have a Yestv icon on your Home Screen?")}</summary>{content}</details> : <section className="install-reminder" aria-label={t("Avoid duplicate icons")}><strong>{t("Already have a Yestv icon on your Home Screen?")}</strong>{content}</section>;
}
